module.exports = __webpack_public_path__ + "static/media/profile.dc238e0b.png";